import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { PeriodProvider } from "@/contexts/PeriodContext";
import { SettingsProvider } from "@/contexts/SettingsContext";
import Login from "@/pages/Login";
import Landing from "@/pages/Landing";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import ExpensesPage from "@/pages/ExpensesPage";
import IncomesPage from "@/pages/IncomesPage";
import SavingsPage from "@/pages/SavingsPage";
import FilesPage from "@/pages/FilesPage";
import PwaIdentity from "@/components/PwaIdentity";
import "@/App.css";

function Loader() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div>
        <span className="loader-dot"></span>
        <span className="loader-dot"></span>
        <span className="loader-dot"></span>
      </div>
    </div>
  );
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  return (
    <PeriodProvider>
      <SettingsProvider>{children}</SettingsProvider>
    </PeriodProvider>
  );
}

function Public({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loader />;
  if (user) return <Navigate to="/app" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <PwaIdentity />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Public><Landing /></Public>} />
          <Route path="/login" element={<Public><Login /></Public>} />
          <Route path="/register" element={<Public><Register /></Public>} />
          <Route path="/forgot-password" element={<Public><ForgotPassword /></Public>} />
          <Route path="/reset-password" element={<Public><ResetPassword /></Public>} />
          <Route path="/app" element={<Protected><Dashboard /></Protected>} />
          <Route path="/app/expenses" element={<Protected><ExpensesPage /></Protected>} />
          <Route path="/app/incomes" element={<Protected><IncomesPage /></Protected>} />
          <Route path="/app/savings" element={<Protected><SavingsPage /></Protected>} />
          <Route path="/app/files" element={<Protected><FilesPage /></Protected>} />
          {/* Legacy redirects */}
          <Route path="/expenses" element={<Navigate to="/app/expenses" replace />} />
          <Route path="/incomes" element={<Navigate to="/app/incomes" replace />} />
          <Route path="/savings" element={<Navigate to="/app/savings" replace />} />
          <Route path="/files" element={<Navigate to="/app/files" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
